import React, {Component} from 'react'
import {connect} from "react-redux";
import {Col, ControlLabel, Radio, Row} from "react-bootstrap";
import BackLink from '../../../../common/back-link';
import PageTitle from "../../../../common/page-title";
import {getGroups} from "../../../../../actions/products";
import {getPromotionalBanner, savePromotionalBanner, updatePromotionalBanner} from "../../../../../actions/promotional_banners";
import {actions, Control, Form} from "react-redux-form";
import RequiredInput from "../../../../common/form/elements/required-input";
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker';
import RequiredMultiSelect from "../../../../common/form/elements/required-multi-select";
import ArrowButton from '../../../../common/button-arrow';
import ImageUpload from "../../../../common/form/elements/image-upload";
import {validators} from "../../../../../utils/validators";

class NewPromotionalBanner extends Component {
  constructor(props) {
    super(props);
    this.id = this.props.match.params.id;
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getGroups());
    if (this.isEdit()) {
      dispatch(getPromotionalBanner(this.id)).then((promotional_banner) => {
        dispatch(actions.load('deep.admin_promotional_banner_save', promotional_banner));
      });
    } else {
      dispatch(actions.reset('deep.admin_promotional_banner_save'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch({type: 'CLEAR_PROMOTIONAL_BANNERS'});
    this.props.dispatch(actions.reset('deep.admin_promotional_banner_save'));
  }

  isEdit = () => this.id && parseInt(this.id);

  isPromotionalBannerLoading = () => this.isEdit() && this.props.promotional_bannerLoading;

  handleSubmit = (payLoad) => {
    const {dispatch} = this.props;
    if (this.isEdit()) {
      dispatch(updatePromotionalBanner(this.id, payLoad));
    } else {
      dispatch(savePromotionalBanner(payLoad));
    }
  };

  createGroupList = groups => groups.map((curr) => ({
    label: `${curr.name}`,
    value: curr.id
  }));

  handleChange(event, that) {
    const {dispatch} = this.props;
    let model='deep.admin_promotional_banner_save.group_ids';

    dispatch(actions.setErrors(model, {
      required: event.target.value !== "true"
    }));

    if(event.target.value === "true"){
      dispatch(actions.change(model, []));
    }
  }

  render() {
    const {promotional_banner, groups: groupList, savedGroups, formValid} = this.props;
    const groups = this.createGroupList(groupList);
    const displayFromDate = promotional_banner ? promotional_banner.display_from_date : '';
    const displayToDate = promotional_banner ? promotional_banner.display_to_date : '';

    if (this.isPromotionalBannerLoading()) {
      return (
        <div className="container-fluid">
          <PageTitle>{this.isEdit() ? 'Edit Promotional Banner' : 'Add Promotional Banner'}</PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      )
    }

    let image = '';
    if (this.props.formData.hasOwnProperty('links') && this.props.formData.links.hasOwnProperty('image')) {
      image = this.props.formData.links.image;
    }

    return (
      <div className="container-fluid">
        <Form model="deep.admin_promotional_banner_save" onSubmit={(data) => this.handleSubmit(data)}>
          <Row>
            <Col lg={12}>
              <BackLink href="/admin/promotional_banners"/>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <PageTitle>{this.isEdit() ? 'Edit Promotional Banner' : 'Add Promotional Banner'}</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                label="Name"
                placeholder="Name"
                model='.name'
                controlId='name'
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ControlLabel>Image*</ControlLabel>
              <ImageUpload
                onImageLoaded={this.onImageLoaded}
                source={image}
                label={"Upload an image (1500 x 300)"}
                model="deep.admin_promotional_banner_save.image"
                type={['image/png', 'image/jpg', 'image/jpeg', 'image/gif']}
                required/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                <ControlLabel>Default*</ControlLabel>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Control.radio
                model="deep.admin_promotional_banner_save.default"
                value="true"
                validators={{required: validators.required(this.updateErrors, 'default')}}
                component={Radio}
                onClick={this.handleChange.bind(this)}
              >
                Yes
              </Control.radio>
              <Control.radio
                model="deep.admin_promotional_banner_save.default"
                value="false"
                validators={{required: validators.required(this.updateErrors, 'default')}}
                component={Radio}
                onClick={this.handleChange.bind(this)}
              >
                No
              </Control.radio>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredDatePicker
                label='Display from date'
                placeholder='Display from date'
                model="deep.admin_promotional_banner_save.display_from_date"
                controlId="display_from_date"
                value={displayFromDate}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredDatePicker
                label='Display to date'
                placeholder='Display to date'
                model="deep.admin_promotional_banner_save.display_to_date"
                controlId="display_to_date"
                value={displayToDate}
              />
            </Col>
          </Row>
          {this.props.formData.default !== "true" &&
          <Row>
            <Col lg={12}>
              <RequiredMultiSelect
                data={groups || []}
                label="Group(s)"
                value={savedGroups}
                controlId="groups"
                model='deep.admin_promotional_banner_save.group_ids'
              />
            </Col>
          </Row>
          }
          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton
                className="pull-right"
                arrow={false}
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  formData: state.deep.admin_promotional_banner_save,
  formValid: state.deep.forms.admin_promotional_banner_save.$form.valid,
  promotional_banner: state.promotionalBanners.promotional_banner,
  promotional_bannerLoading: state.promotionalBanners.fetching && !state.promotionalBanners.fetched,
  savedGroups: state.deep.admin_promotional_banner_save.group_ids || [],
  groups: state.groupSelector.groups || []
});

export default connect(mapStateToProps)(NewPromotionalBanner);



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotional_banners/add/index.jsx